module.exports = __webpack_public_path__ + "img/ercikaifa.a26f0c93.png";